module.exports = __webpack_public_path__ + "static/media/29BDOS2.ac9e7158.jpg";